import React from "react";
import withRoot from "../withRoot";
import Layout from "../components/Layout";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import {Link, graphql} from "gatsby";
import Img from "gatsby-image";
import { withStyles } from "@material-ui/core";

import Envs from "../data/envs/env";

const styles = {};

class Env extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      game: ""
    };
  }

  render() {
    const { classes, data } = this.props;
    return (
      <Layout>
        <Grid container alignItems="stretch" justify="center" spacing={24}>
          <Grid item md={12}>
            <Typography variant="h1" align="left">
              Environments
            </Typography>
          </Grid>
          {Envs.map(env => (
            (<Grid item md={6} sm={12} xs={12} key={env.name}>
              <Card raised className={classes.textEditor}>
                <CardContent>
                  <Typography variant="h6">
                    {env.name}
                  </Typography>
                  <Grid container justify="center">
                    <Img
                      fixed={data[env.slug].childImageSharp.fixed}
                      alt={`${env.title}-preview`}
                    />
                  </Grid>
                  <Typography variant="body1">
                    {env.description}
                  </Typography>
                </CardContent>
                <Divider />
                <CardActions>
                  <Grid container justify="flex-end">
                  <a href={`https://ttumiel.github.io/gym.js/classes/${env.slug}.html`}>
                    <Button
                      size="small"
                      color="primary"
                    >
                      Open Docs
                    </Button>
                    </a>
                    <Link to={`/env/${env.slug}`}>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={this.deployModel}
                      color="primary"
                    >
                      Open Environment
                    </Button>
                    </Link>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>)
          ))}
        </Grid>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    frozenlake: file(relativePath: { eq: "frozenlake.png" }) {
      childImageSharp {
        fixed(width: 110) {
          ...GatsbyImageSharpFixed_withWebp_tracedSVG
        }
      }
    }
    copy: file(relativePath: { eq: "copy.png" }) {
      childImageSharp {
        fixed(width: 67) {
          ...GatsbyImageSharpFixed_withWebp_tracedSVG
        }
      }
    }
    reverse: file(relativePath: { eq: "reverse.png" }) {
      childImageSharp {
        fixed(width: 85) {
          ...GatsbyImageSharpFixed_withWebp_tracedSVG
        }
      }
    }
    snake: file(relativePath: { eq: "snake.png" }) {
      childImageSharp {
        fixed(width: 260) {
          ...GatsbyImageSharpFixed_withWebp_tracedSVG
        }
      }
    }
  }
`;

export default withRoot(withStyles(styles)(Env));
